import ErrorIcon from 'assets/icons/ErrorIcon'
import ModalContainer from './ModalContainer'
import RoundedIcon from './RoundedIcon'

import card from '../assets/images/WayniCard.png'
import PrimaryButton from './primaryButton'

const PhysicalCardRequestErrorModal = ({ isOpen, setIsOpen }) => (
  <ModalContainer noCloseButton isShown={isOpen} setModalFunction={setIsOpen}>
    <div className='flex flex-col items-center text-center text-black leading-5 my-2'>
      <h3 className='font-bold leading-6'>No pudimos solicitar tu tarjeta</h3>
      <ErrorIcon className='my-4' />
      <p>Tuvimos problemas al generar tu tarjeta.</p>
      <p>Por favor, intentá nuevamente.</p>
      <p className='my-4 font-bold text-2xs'>Mientras tanto...</p>
      <div className='flex items-center gap-2 font-medium text-2xs'>
        <RoundedIcon
          className='w-6 h-6'
          icon={<img className='w-4 h-[10px]' src={card} alt='' />}
        />
        <p className='text-left leading-[120%]'>
          Aprovechá tu tarjeta Wayni virtual para hacer compras por internet.
        </p>
      </div>
      <PrimaryButton
        buttonText='¡Entendido!'
        className='mt-14 w-full'
        primaryButtonFunction={() => {
          setIsOpen(false)
        }}
      />
    </div>
  </ModalContainer>
)

export default PhysicalCardRequestErrorModal
